<template>
    <v-dialog v-model="voiceformdialog">
        <v-card>
            <v-container fluid>
                <v-row no-gutters>
                    <h1>{{ formTitle }}</h1>
                    <v-spacer></v-spacer>
                    <v-switch
                        v-model="gmwSwitch"
                        color="red"
                        label="GMW"
                        hide-details
                        :disabled="disabledGMWSwitch"
                    ></v-switch>
                    <v-btn icon @click="ToggleMic" >
                        <v-icon :color="miccolor">mdi-microphone</v-icon>
                    </v-btn>
                </v-row>
                <v-row>
                    <v-text-field label="Transcript" v-model="transcript">

                    </v-text-field>
                </v-row>
                <v-form @submit.prevent="">
                    <v-row>
                        <v-col cols="12" sm="5">
                            <v-autocomplete
                                ref="partyfocus"
                                label="Party Name"
                                v-model="bill.bills_partyname"
                                :items="parties"
                                item-title="partydetails"
                                item-value="parties_partyname"
                                density="default"
                                placeholder="Party name"
                                auto-select-first
                                item-props
                                clearable
                                :update:modelValue="previoussalesdata()"  
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="1">
                            <v-text-field label="Case" v-model="bill.caseno" type='number' required v-on:change="bill.caseno = Number(bill.caseno)"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field label="Transport" v-model="bill.transport"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="1">
                            <v-autocomplete
                                label="Con"
                                v-model="bill.console"
                                :items="consoles"
                                density="default"
                                placeholder="Con"
                                auto-select-first
                                item-props
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="1">
                            <v-autocomplete
                                label="year"
                                v-model="bill.bills_year"
                                :items="years"
                                item-title="year_year"
                                item-value="year_year"
                                density="default"
                                placeholder="Year"
                                auto-select-first
                                item-props
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="1">
                            <v-text-field label="Bill No" v-model="bill.billno" readonly required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="1">
                            <v-text-field label="Date" v-model="bill.billdate" type='date' required></v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
        </v-card>

    </v-dialog>
</template>
<script setup>
import { ref, provide, computed, onMounted,onBeforeMount,watch } from 'vue'
import { useAuthStore } from '@/stores/AuthStore'
import ProductService from '@/services/ProductService'
import PartyService from '@/services/PartyService'
import YearService from '@/services/YearService'
import BillService from '@/services/BillService'
import ShowError from '@/components/Showerror'
import BatchService from '@/services/BatchService'
import ProductsalesService from '@/services/ProductsalesService'
import router from '@/router'

const props = defineProps(['showVoiceForm','editedItem','editedIndex', 'updateID'])
const emit = defineEmits(['closedialog'])

const authStore = useAuthStore()

var formTitle = ref((props.editedIndex == -1) ? 'New Bill': 'Edit Bill')
var voiceformdialog = ref(props.showVoiceForm)

var gmwSwitch = ref(authStore.gmswitch)
var disabledGMWSwitch = ref((props.editedIndex == -1) ? false: true)
var productcolor = ref((authStore.gmswitch) ? 'deep-orange accent-4':'deep-purple accent-4')

var showMessage = ref(false)
var msgStatus = ref('primary')
var msg = ref('This is msg')

var bill = ref(props.editedItem)
var parties = ref([])
var partiesgm = ref([])
var partiesgmw = ref([])
var selectedParty = ref({})
var consoles = ref((gmwSwitch.value) ? ['GM1','GM2','CN'] : ['GM1','GM2','SM1','SM2','CN','CNSM','Enter','Sample'])
var years = ref([])
var productnames = ref([])
var batches = ref([])
var prevsales = ref([])
var productautofocus = ref(false)
var editeditemsales = []
var partyfocus = ref(null)



const transcript = ref('')
const isRecording = ref(false)
const miccolor = ref('blue')
const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition
const sr =  new Recognition()



provide('msgStatus', msgStatus)
provide('msg', msg)
provide('showMessage', showMessage)

async function startlistening(){
    console.log("Start Listening is clicked")
}

onMounted(() => {
    sr.continuous = true
    sr.interimResults = true
    sr.onstart = () => {
        console.log("SR started")
        isRecording.value = true

    }

    sr.onend = () => {
        console.log("SR stopped")
        isRecording.value = false
    }

    sr.onresult = (evt) => {
        for(let i=0; i<evt.results.length; i++){
            const result = evt.results[i]

            if(result.isFinal){
                checkforcommand(result)
            }
        }

        //console.log(evt)
        const t = Array.from(evt.results)
        .map(result => result[0])
        .map(result => result.transcript)
        .join('')

        console.log(t)
        transcript.value = t
        if(partyfocus.value.menu){
            //bill.bills_partyname.value = t
            //partyfocus.value = "hello"
            bill.value.bills_partyname = transcript.value
            console.log("This will be written in the v-model "+transcript.value)
        }
    }
})

const ToggleMic = () => {
    //this.$ref.bill.bills_partyname.focus()
    
    if(isRecording.value){
        sr.stop()
    }else{
        sr.start()
    }
}

const checkforcommand = (result) => {
    const t = result[0].transcript
    if(t.includes('party')) {
        sr.stop()
        console.log("Open the Party dropdown")
        partyfocus.value.menu = true
        setTimeout(() => sr.start(), 200)
    }else if(
        t.includes('Product') ||
        t.includes('products')
    ){
        sr.stop()
        console.log("Open the products")
        setTimeout(() => sr.start(), 200)
    }
}

async function addnewproduct(){
    if(typeof bill.value.bills_partyname !== 'undefined'){
        bill.value.productsales.push({
            productname:'',
            batchno:'',
            expdate:'',
            mrp:'',
            newmrp:'',
            rate:'',
            qty:'',
            free:'',
            discount:0,
            igst_rate:0,
            cgst_rate:0,
            sgst_rate:0,
            total:0
        })
        productautofocus.value = true
    // var max_productsales = (bill.value.productsales.length -1)
    
    }else{
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = "Party is not selected" 
        
    }
    
}
async function create(){
    try{
        if(gmwSwitch.value){
            await BillService.creategmw(bill.value)
        }else{
            await BillService.create(bill.value)
        }
        voiceformdialog.value = false
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
    
}
async function update(){
    try{
        if(gmwSwitch.value){
            await BillService.updategmw(bill.value,props.updateID)
        }else{
            await BillService.update(bill.value,props.updateID)
        }
        voiceformdialog.value = false
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
}
async function removeProduct(i){
    bill.value.productsales.splice(i,1)
    //call the calculation program
}
async function gettotalvalue(){
    var taxable = 0
    var igst = 0
    var cgst = 0
    var sgst = 0
    
    for(let i = 0; i < bill.value.productsales.length; i++){
        var rate = Number(bill.value.productsales[i].rate)
        var qty = Number(bill.value.productsales[i].qty)
        var discountpercent = Number(bill.value.productsales[i].discount)
        var igstpercent = Number(bill.value.productsales[i].igst_rate)
        var cgstpercent = Number(bill.value.productsales[i].cgst_rate)
        var sgstpercent = Number(bill.value.productsales[i].sgst_rate)
        var value = Math.round((rate * qty) * 100) / 100
        var discountvalue = Math.round((value * discountpercent /100) * 100) / 100
        var eachtaxable = Math.round((value - discountvalue) * 100) / 100
        var igstvalue = Math.round((eachtaxable * igstpercent / 100) * 100) / 100
        var cgstvalue = Math.round((eachtaxable * cgstpercent / 100) * 100) / 100
        var sgstvalue = Math.round((eachtaxable * sgstpercent / 100) * 100) / 100
        taxable = Math.round((taxable + eachtaxable) * 100) / 100
        igst = Math.round((igst + igstvalue) * 100) / 100
        cgst = Math.round((cgst + cgstvalue) * 100) / 100
        sgst = Math.round((sgst + sgstvalue) * 100) / 100
    }

    bill.value.total = taxable
    bill.value.bills_igst = igst
    bill.value.bills_cgst = cgst
    bill.value.bills_sgst = sgst
    var billamount = Math.round(taxable + igst + cgst + sgst)
    bill.value.billamount = billamount
    bill.value.overdue = billamount
    bill.value.amount = billamount
}

async function productselected(i){
    var selectedproduct = bill.value.productsales[i].productname
    if(selectedproduct != ''){
        var filteredproduct = productnames.value.filter(function(el){
            return el.productnames_productname == selectedproduct
        })[0]

        var filteredproductexist = (typeof filteredproduct !== 'undefined')

        if(filteredproductexist){
            bill.value.productsales[i].hsncode = filteredproduct.hsn.hsn_code
            if(bill.value.bills_state != 'West Bengal'){
                bill.value.productsales[i].igst_rate = Number(filteredproduct.hsn.hsn_igstrate)
                bill.value.productsales[i].cgst_rate = 0
                bill.value.productsales[i].sgst_rate = 0
            }else{
                bill.value.productsales[i].igst_rate = 0
                bill.value.productsales[i].cgst_rate = Number(filteredproduct.hsn.hsn_cgstrate)
                bill.value.productsales[i].sgst_rate = Number(filteredproduct.hsn.hst_sgstrate)
            }
        }
        
    }
    
}
async function batchselected(i){
    var selectedproduct = bill.value.productsales[i].productname
    var selectedbatch = bill.value.productsales[i].batchno
    
    if(selectedproduct != '' && selectedbatch != ''){
        
        var filteredbatch = batches.value.filter(function(el){
            return el.productname == selectedproduct &&
                    el.batchno == selectedbatch
            })[0]

        var filteredbatchexist = (typeof filteredbatch !== 'undefined')

        var filteredprevsales = prevsales.value.filter(function(el){
            return el.productname == selectedproduct
        })[0]

        var prevsalesexist = (typeof filteredprevsales !== 'undefined')
                         
        if(filteredbatchexist){
            bill.value.productsales[i].expdate = filteredbatch.expdate
            bill.value.productsales[i].mrp = filteredbatch.mrp
            var mrp = Number(bill.value.productsales[i].mrp)
            var igstrate = Number(bill.value.productsales[i].igst_rate)
            var cgstrate = Number(bill.value.productsales[i].cgst_rate)
            var sgstrate = Number(bill.value.productsales[i].sgst_rate)

            var gstrate = (igstrate > 0 ) ? igstrate : (cgstrate + sgstrate)
            //console.log("MRP is "+mrp)
            //console.log("GST Rate is "+gstrate)
            var rate = Math.round(((mrp - mrp*0.2)/((100 + gstrate)/100))*100)/100
            

            if(prevsalesexist){
                //console.log("Rate is "+ rate)
                bill.value.productsales[i].rate = (filteredprevsales.discount == 0) ? filteredprevsales.rate : rate
                bill.value.productsales[i].discount = (filteredprevsales.discount == 0) ? 0 : filteredprevsales.discount
                //Show snackbar if MRP changed
                if((filteredprevsales.mrp != filteredbatch.mrp) && filteredprevsales.discount == 0){
                    showMessage.value = true
                    msgStatus.value = 'error'
                    msg.value = "MRP has changed"
                }
            }else{
                bill.value.productsales[i].rate = rate
                //bill.value.productsales[i].discount = 0

            }

        }

        var filteredproduct = productnames.value.filter(function(el){
            return el.productnames_productname == selectedproduct
        })[0]

        var filteredproductexist = (typeof filteredproduct !== 'undefined')

        if(filteredproductexist){
            var original_igst_rate = 0
            var original_cgst_rate = 0
            var original_sgst_rate = 0
            if(bill.value.bills_state != 'West Bengal'){
                original_igst_rate = Number(filteredproduct.hsn.hsn_igstrate)
                original_cgst_rate = 0
                original_sgst_rate = 0
            }else{
                original_igst_rate = 0
                original_cgst_rate = Number(filteredproduct.hsn.hsn_cgstrate)
                original_sgst_rate = Number(filteredproduct.hsn.hst_sgstrate)
            }

            var original_gstrate = (original_igst_rate > 0 ) ? original_igst_rate : (original_cgst_rate + original_sgst_rate)
            var newmrp = 0.00
            if(original_gstrate == 5){
                newmrp = mrp
            }else{
                newmrp = Math.round((mrp*105/(100+original_gstrate))*100)/100
            }

            bill.value.productsales[i].newmrp = newmrp
        }

        //Following code is for GST 2.0. GST Rate change to 5% for all product
        if(bill.value.bills_state != 'West Bengal'){
            bill.value.productsales[i].igst_rate = 5
            bill.value.productsales[i].cgst_rate = 0
            bill.value.productsales[i].sgst_rate = 0
        }else{
            bill.value.productsales[i].igst_rate = 0
            bill.value.productsales[i].cgst_rate = 2.5
            bill.value.productsales[i].sgst_rate = 2.5
        }
        
    }  
}

async function existsinediteditem(product, batch){
    var itemexist = false
    var filteredbatch = editeditemsales.filter(function(el){
            return el.productname == product &&
                    el.batchno == batch
            })
    if(filteredbatch.length > 0){
        itemexist = true
    }
    return itemexist
}

async function previoussalesdata(){
    var party = bill.value.bills_partyname
    try{
        var product = gmwSwitch.value ? (await ProductsalesService.getprevsalesgmw(party)).data : (await ProductsalesService.getprevsales(party)).data
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
    prevsales.value = product
    return product
}
function closesnackbar (){
    showMessage.value = false
}
async function buttonClick(){
    for (let i = 0; i < bill.value.productsales.length; i++){
        bill.value.productsales[i].productsales_ebillid =  bill.value.bills_ebillid,
        bill.value.productsales[i].productsales_partyname = bill.value.bills_partyname,
        bill.value.productsales[i].year = bill.value.bills_year,
        bill.value.productsales[i].console = bill.value.console,
        bill.value.productsales[i].billno = bill.value.billno,
        bill.value.productsales[i].billdate = bill.value.billdate,
        bill.value.productsales[i].itemid = (await getitemid(bill.value.productsales[i].productname, bill.value.productsales[i].batchno)),
        bill.value.productsales[i].total = (Number(bill.value.productsales[i].qty) + Number(bill.value.productsales[i].free))
        if(props.editedIndex != -1 && !Object.keys(bill.value.productsales[i]).includes('id')){
            bill.value.productsales[i].id = ''
        }
    }

    if(props.editedIndex == -1){
        await create()
    }else{
        await update()
    }
}
async function getitemid(selectedproduct, selectedbatch){
    var itemid = batches.value.filter(function(el){
            return el.productname == selectedproduct &&
                    el.batchno == selectedbatch
            })[0].itemid
    return itemid
}

async function deleteData(){
    
}
onBeforeMount(async () => {
    if(props.editedIndex != -1){
        editeditemsales = props.editedItem.productsales.map(v => ({...v, isOld: true}))
    }
    var gmparties = await getgmparties()
    var gmwparties = await getgmwparties()
    await getproducts()
    await getbatches()
    
    parties.value = (gmwSwitch.value) ? gmwparties : gmparties

    await getyear()
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    var datetopass = yyyy + '-' + mm + '-' + dd;
    if(props.editedIndex == -1){
        bill.value.billdate =  datetopass;
    }
    
    
    
})

async function getgmparties(){
    try{
        var parties = (await PartyService.getall()).data
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
    partiesgm.value = parties
    return parties
}

async function getgmwparties(){
    try{
        var parties = (await PartyService.getallgmw()).data
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
    partiesgmw.value = parties
    return parties
}

async function getyear(){
    try{
        var year = (await YearService.getall()).data
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
    years.value = year
    bill.value.bills_year = year[0].year_year
    return year
}
async function getproducts(){
    try{
        var product = gmwSwitch.value ? (await ProductService.getallnamesgmw()).data : (await ProductService.getallnames()).data
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
    productnames.value = product
    return product
}

async function getbatches(){
    try{
        var batch = gmwSwitch.value ? (await BatchService.getallgmw()).data : (await BatchService.getall()).data
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
    batches.value = batch
    return batch
}

async function getebillid(){
    try{
        var ebillid = gmwSwitch.value ? (await BillService.getebillidgmw()).data : (await BillService.getebillid()).data
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
    bill.value.bills_ebillid = ebillid.ebillid
    return ebillid
}
async function getnum(year,con){
    try{
        var num = gmwSwitch.value ? (await BillService.getnumgmw(year,con)).data : (await BillService.getnum(year,con)).data
    }catch(err){
        showMessage.value = true
        msgStatus.value = 'error'
        msg.value = err.response.data.error
    }
    bill.value.num = num.num
    bill.value.billno = num.billno
    return num
}

watch(gmwSwitch, async(val)=>{
    authStore.setGmswitch()
    productcolor.value = (gmwSwitch.value) ? 'deep-orange accent-4':'deep-purple accent-4'
})

watch(voiceformdialog, async(val)=>{
    if(voiceformdialog.value===false){
        emit('closedialog')
    }
})

watch(isRecording, async(val)=>{
    miccolor.value = isRecording.value ? "red" : "green"
})

watch(() => [bill.value.bills_partyname], async(val)=>{
    var party = parties.value.filter(function (obj) {
            return obj.parties_partyname === bill.value.bills_partyname;
        })[0]
    //var rate = ((newmrp - newmrp*0.2)/((100 + Number(gstrate))/100))
    //batch.value.rate = Math.round(rate*100)/100
    var partyexist = (typeof party !== 'undefined')
    
    if(partyexist){
        selectedParty.value = party
        bill.value.transport = party.transport
        bill.value.console = party.con
        bill.value.bills_state = party.parties_state

    }
    

})

watch(() => [gmwSwitch.value, bill.value.console, bill.value.bills_year,bill.value.bills_partyname], async(val)=>{
    var year = bill.value.bills_year
    var con = bill.value.console

    disabledGMWSwitch.value = (bill.value.console == 'GM1' || bill.value.console == 'GM2' || bill.value.console == 'CN') ? false : true
    consoles.value = (gmwSwitch.value) ? ['GM1','GM2','CN'] : ['GM1','GM2','SM1','SM2','CN','CNSM','Enter','Sample']
    await getebillid()
    await getnum(year,con)

    
})

const qtycomputed = computed(() => {
  return bill.value.productsales.map(pd => pd.qty)
})
const ratecomputed = computed(() => {
  return bill.value.productsales.map(pd => pd.rate)
})
const discountcomputed = computed(() => {
  return bill.value.productsales.map(pd => pd.discount)
})

const productcomputed = computed(() => {
  return bill.value.productsales.map(pd => pd.productname)
})

watch(() => [qtycomputed, ratecomputed, discountcomputed], async(val)=>{
    await gettotalvalue()
    
},{ deep: true })
</script>